import {HttpInterceptorFn, HttpResponse} from '@angular/common/http'
import {inject} from '@angular/core'
import {of, switchMap, tap} from 'rxjs'
import {CACHE_FORCE_REFRESH, CACHING_ENABLED, CACHING_TTL} from '../config/http.config'
import {CacheService} from '../services'

export const cachingInterceptor: HttpInterceptorFn = (req, next) => {
  const cacheService = inject(CacheService)

  if (req.context.get(CACHING_ENABLED)) {
    const cacheKey = cacheService.generateCacheKey(req.urlWithParams, req.method, req.body)
    const cacheTTL = req.context.get(CACHING_TTL)
    const cacheForceRefresh = req.context.get(CACHE_FORCE_REFRESH)

    return cacheService.get(cacheKey).pipe(
      switchMap((cachedResponse) => {
        if (cachedResponse && !cacheForceRefresh) {
          return of(new HttpResponse({ body: cachedResponse }))
        }

        return next(req).pipe(
          tap((event) => {
            if (event instanceof HttpResponse) {
              cacheService.put(cacheKey, event.body, cacheTTL).subscribe()
            }
          })
        )
      })
    )
  } else {
    return next(req)
  }
}
